module.exports = __webpack_public_path__ + "img/60.98c56ca7.svg";